import {CommonLink} from '../../../../../shared/components/CommonLink';
import type {CompanyPageYearlyItem} from './CompanyRecruitmentGuideTable';

// 企業データ
type Props = {
  establishmentDate: string;
  businessDescription: string;
  websiteUrl: string;
  address: string;
  capital: string;
  representativePerson: string;
  employeesCount: string;
  extraItems: CompanyPageYearlyItem[];
};

export const CompanyInfoTable: React.FC<Props> = ({
  establishmentDate,
  businessDescription,
  websiteUrl,
  address,
  capital,
  representativePerson,
  employeesCount,
  extraItems,
}) => {
  return (
    <div className="pc:mt-8 p-16 pc:px-[256px] bg-white rounded-b-[12px] rounded-t-[4px] border-t-[1px] border-solid border-t-line-1 pc:border-t-[0px]">
      <table className="px-16 w-full hidden pc:table mt-12">
        <tbody>
          <tr>
            <th className="text-left font-bold w-[130px]">
              <div className="my-4 px-16 py-8">設立日</div>
            </th>
            <td className="px-16">
              <div className="py-8 pl-16 whitespace-pre-wrap">
                {establishmentDate}
              </div>
            </td>
          </tr>
          <tr>
            <th className="text-left font-bold">
              <div className="my-4 px-16 py-8">事業内容</div>
            </th>
            <td className="px-16">
              <div className="py-8 pl-16 whitespace-pre-wrap">
                {businessDescription}
              </div>
            </td>
          </tr>
          <tr>
            <th className="text-left font-bold">
              <div className="my-4 px-16 py-8">URL</div>
            </th>
            <td className="px-16">
              <div className="py-8 pl-16 whitespace-pre-wrap">
                <CommonLink
                  href={websiteUrl}
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="text-link hover:text-primary hover:underline"
                >
                  {websiteUrl}
                </CommonLink>
              </div>
            </td>
          </tr>
          <tr>
            <th className="text-left font-bold">
              <div className="my-4  px-16 py-8">住所</div>
            </th>
            <td className="px-16">
              <div className="py-8 pl-16 whitespace-pre-wrap">{address}</div>
            </td>
          </tr>
          <tr>
            <th className="text-left font-bold">
              <div className="my-4  px-16 py-8 pc:w-[130px]">資本金</div>
            </th>
            <td className="px-16">
              <div className="py-8 pl-16 whitespace-pre-wrap">{capital}</div>
            </td>
          </tr>
          <tr>
            <th className="text-left font-bold">
              <div className="my-4  px-16 py-8 pc:w-[130px]">代表者</div>
            </th>
            <td className="px-16">
              <div className="py-8 pl-16 whitespace-pre-wrap">
                {representativePerson}
              </div>
            </td>
          </tr>
          <tr>
            <th className="text-left font-bold pc:w-[130px]">
              <div className="my-4  px-16 py-8 pc:w-[130px]">従業員数</div>
            </th>
            <td className="px-16">
              <div className="py-8 pl-16 whitespace-pre-wrap">
                {employeesCount}
              </div>
            </td>
          </tr>
          {extraItems.length > 0 &&
            extraItems.map((item, index) => (
              <tr key={index}>
                <th className="text-left font-bold">
                  <div className="my-4  px-16 py-8">{item.label}</div>
                </th>
                <td className="px-16">
                  <div className="py-8 pl-16 whitespace-pre-wrap">
                    {item.value}
                  </div>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
      {/* SP */}
      <div className="pc:hidden sm:px-0">
        <div>
          <h3 className="text-lg font-bold leading-none pb-8">設立日</h3>
          <div className="pl-8">{establishmentDate}</div>
        </div>
        <h3 className="text-lg font-bold leading-none pt-20 pb-8">事業内容</h3>
        <div className="pl-8 whitespace-pre-wrap">{businessDescription}</div>
        <h3 className="text-lg font-bold leading-none pt-20 pb-8">URL</h3>
        <div className="pl-8 break-all">
          <CommonLink
            href={websiteUrl}
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="text-link hover:text-primary hover:underline"
          >
            {websiteUrl}
          </CommonLink>
        </div>
        <h3 className="text-lg font-bold leading-none pt-20 pb-8">住所</h3>
        <div className="pl-8">{address}</div>
        <h3 className="text-lg font-bold leading-none pt-20 pb-8">資本金</h3>
        <div className="pl-8">{capital}</div>
        <h3 className="text-lg font-bold leading-none pt-20 pb-8">代表者</h3>
        <div className="pl-8">{representativePerson}</div>
        <h3 className="text-lg font-bold leading-none pt-20 pb-8">従業員数</h3>
        <div className="pl-8">{employeesCount}</div>
      </div>
    </div>
  );
};
